/*
 * サブシステム名：経営管理
 * 機能名：荷主別請求集計表
 */

import DdNumericBox from '@/components/DdNumericBox'
import DdSubHeader from '@/components/DdSubHeader'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import DdDateBox from '@/components/DdDateBox'
import DdCodeTextBox from '../../components/DdCodeTextBox.vue'
import DdTextBox from '../../components/DdTextBox.vue'
import DdYearMonthBoxWithSelector from '@/components/DdYearMonthBoxWithSelector.vue'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'
import header from '@/ddv2.library/header'
import validators from '@/rahmen/validators'

export default {
  name: 'NinushiSeikyuShukei',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {
      eigyoshoCd: '',
      torihikisakiCd: '',
      seikyuYoteiStartYm: '',
      seikyuYoteiEndYm: ''
    },
    kingaku1Kei: 0,
    taxPriceKei: 0,
    shokeiKei: 0,
    etcPriceKei: 0,
    gokeiSeikyuKingakuKei: 0,
    headersEigyoshoList: header.mstEigyoshoHeaders,
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    modeKengen: 0,
    isShoukaiMode: false,
    page: 1,
    isCsvDownloader: false,
    isPdfDownloader: false
  }),
  components: {
    DdNumericBox,
    DdSubHeader,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdCodeTextBox,
    DdRowCountBox,
    DdFooterButton,
    DdDataTable,
    DdDateBox,
    DdTextBox,
    DdYearMonthBoxWithSelector
  },
  computed: {
    filteredRows () {
      console.log('●●filterdRows:this.rows', this.rows)
      return this.rows.map((elem) => {
        elem.kingaku1Disp = elem.kingaku1 === 0 || elem.kingaku1 ? filter.numericFormatter(elem.kingaku1) : ''
        elem.taxPriceDisp = elem.taxPrice === 0 || elem.taxPrice ? filter.numericFormatter(elem.taxPrice) : ''
        elem.shokeiDisp = elem.shokei === 0 || elem.shokei ? filter.numericFormatter(elem.shokei) : ''
        elem.etcPriceDisp = elem.etcPrice === 0 || elem.etcPrice ? filter.numericFormatter(elem.etcPrice) : ''
        elem.gokeiSeikyuKingakuDisp = elem.gokeiSeikyuKingaku === 0 || elem.gokeiSeikyuKingaku ? filter.numericFormatter(elem.gokeiSeikyuKingaku) : ''
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0 || this.isCsvDownloader
    },
    isPdfButtonDisabled () {
      return this.rows.length === 0 || this.isPdfDownloader
    },
    isPrintButtonDisabled () {
      return false
    },
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      usersEigyoshoCd: 'users/eigyoshoCd'
    }),
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredTorihikisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        conditions: this.conditions,
        searchText: this.searchText,
        rows: this.rows
      }
    },
    settingSeikyuYoteiStartYm: function (p) {
      this.conditions.seikyuYoteiStartYm = p
    },
    settingSeikyuYoteiEndYm: function (p) {
      this.conditions.seikyuYoteiEndYm = p
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'msteigyosho'],
        defineHeaderPromise: () => {
          return new Promise((resolve) => {
            console.log('NinushiSeikyuShukei.defineHeaderPromise')
            self.headers = [
              { text: '荷主コード', value: 'torihikisakiCd', width: '80px' },
              { text: '荷主先', value: 'torihikisakiNm', width: '150px' },
              { text: '営業所', value: 'eigyoshoNm', width: '100px' },
              { text: '課税額', value: 'kingaku1Disp', width: '120px', align: 'end' },
              { text: '消費税', value: 'taxPriceDisp', width: '130px', align: 'end' },
              { text: '小計', value: 'shokeiDisp', width: '130px', align: 'end' },
              { text: 'その他実費', value: 'etcPriceDisp', width: '130px', align: 'end' },
              { text: '請求額', value: 'gokeiSeikyuKingakuDisp', width: '130px', align: 'end' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            console.log('initializeInputPromise')
            const thisYmString = `${new Date().getFullYear()}/${('0' + (new Date().getMonth() + 1)).slice(-2)}`
            self.conditions = {
              eigyoshoCd: self.usersEigyoshoCd,
              torihikisakiCd: '',
              seikyuYoteiStartYm: thisYmString,
              seikyuYoteiEndYm: thisYmString,
              shimeDay: ''
            }
            self.kingaku1Kei = 0
            self.taxPriceKei = 0
            self.shokeiKei = 0
            self.etcPriceKei = 0
            self.gokeiSeikyuKingakuKei = 0
            self.searchText = ''
            self.rows = []

            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('NinushiSeikyuShukei.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('NinushiSeikyuShukei.savedInputRestorePromise after loadFromCache', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('NinushiSeikyuShukei.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('NinushiSeikyuShukei.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCThbzmd003001/Search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload
          console.log('●●self.rows：', self.rows, self.rows.length)

          self.kingaku1Kei = 0
          self.taxPriceKei = 0
          self.shokeiKei = 0
          self.etcPriceKei = 0
          self.gokeiSeikyuKingakuKei = 0

          for (let i = 0; i < self.rows.length; i++) {
            // (1)課税額計
            self.kingaku1Kei = self.kingaku1Kei + self.rows[i].kingaku1
            // (2)消費税計
            self.taxPriceKei = self.taxPriceKei + self.rows[i].taxPrice
            // (4)その他実費計
            self.etcPriceKei = self.etcPriceKei + self.rows[i].etcPrice
          }
          // (3)小計計((1)+(2))
          self.shokeiKei = self.kingaku1Kei + self.taxPriceKei
          // (5)請求額計((3)+(4))
          self.gokeiSeikyuKingakuKei = self.shokeiKei + self.etcPriceKei

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
          }
        }
      }
      this.search(opt)
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      console.log('clear pushed')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            const thisYmString = `${new Date().getFullYear()}/${('0' + (new Date().getMonth() + 1)).slice(-2)}`
            self.conditions = {
              eigyoshoCd: self.usersEigyoshoCd,
              torihikisakiCd: '',
              seikyuYoteiStartYm: thisYmString,
              seikyuYoteiEndYm: thisYmString,
              shimeDay: ''
            }
            self.kingaku1Kei = 0
            self.taxPriceKei = 0
            self.shokeiKei = 0
            self.etcPriceKei = 0
            self.gokeiSeikyuKingakuKei = 0
            self.searchText = ''
            self.rows = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onCsvButtonClick: function (e) {
      this.isCsvDownloader = true
      this.HttpClient.post('/api/v1/VwCThbzmd003001/download', this.conditions).then((data) => {
        const bom = new Uint8Array([0xef, 0xbb, 0xbf])
        const blob = new Blob([bom, data], { type: 'text/csv' })
        const elem = document.getElementById('download')
        this.isCsvDownloader = false
        elem.href = window.URL.createObjectURL(blob)
        elem.click()
      })
    },
    onPdfButtonClick: function (e) {
      this.isPdfDownloader = true
      this.HttpClient
        .requestFileByPost('/api/v1/VwCThbzmd003001/pdfdownload', this.conditions)
        .then((data) => {
          const blob = new Blob([data], { type: 'application/pdf' })
          const elem = document.getElementById('pdfdownload')
          this.isPdfDownloader = false
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
        })
    },
    searchValidate: function () {
      var msg = validators.compareDate(this.conditions.seikyuYoteiStartYm, this.conditions.seikyuYoteiEndYm)
      if (msg !== undefined) {
        this.$refs.seikyuYoteiStartYm[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.seikyuYoteiEndYm[this.Ctrls.SET_INVALID_METHOD](msg)
        return false
      }
      return true
    }
  }
}
